import React, { useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/src/all";

const useHeroAnimations = (root: React.MutableRefObject<null>) => {
    const componentSelector = gsap.utils.selector(root);
    gsap.defaults({ ease: "power2.inOut", duration: 0.66 });

    useEffect(() => {
        gsap.set(componentSelector("#header"), { opacity: 0 });

        ScrollTrigger.create({
            trigger: root.current,
            start: "top 80%",
            end: "top 81%",
            once: true,
            onEnter: () => {
                console.log("onEnter");
                gsap.to(componentSelector("#header"), {
                    opacity: 1,
                });
            },
            onKill: () => {
                gsap.to(componentSelector("#header"), {
                    opacity: 1,
                });
            },
        });
    }, []);
};

export default useHeroAnimations;
